import { EntityType } from "../../rl-common/shared/shared/entity-type.enum";

export class AnnotationConfig {
    entityId : string;
    entityType : EntityType;

    constructor(entityId : string, entityType){
        this.entityId = entityId;
        this.entityType = entityType;
    }
}
